genderTypes=[{
	code:'M',name: 'Nam'
},{
	code:'F',name:'Nữ'
}];
clientRoleTypes = [{
	code:'LF', name:'Người được bảo hiểm'
},{
	code:'BN', name:'Người thụ hưởng'
},{
	code:'OW', name:'Bên mua bảo hiểm'
}];
pendingTypes=[{
	codePending:'1',valuePending: 'Chờ thẩm định'
},{
	codePending:'2',valuePending: 'Chờ khách hàng hoàn tất/ bổ sung thủ tục'
}];
marriedTypes=[{
	codeMarried:'S',nameMarried:'Độc thân'
},{
	codeMarried:'M',nameMarried:'Đã lập gia đình'
},{
	codeMarried:'D',nameMarried:'Ly di'
},{
	codeMarried:'W',nameMarried:'Góa'
},{
	codeMarried:'U',nameMarried:'Không xác định'
}];
salutlTypes=[{
	codeSalutl:'ÔNG',nameSalutl:'Ông'
},{
	codeSalutl:'BÀ',nameSalutl:'Bà'
},{
	codeSalutl:'CHÁU',nameSalutl:'Cháu'
},{
	codeSalutl:'CÔ',nameSalutl:'Cô'
},{
	codeSalutl:'QUÝ',nameSalutl:'Quý'
}]
agreeEmailTypes=[{
	valueEmail:'1',nameEmail: 'Thông tin HĐ'
},{
	valueEmail:'3',nameEmail: 'Thông tin HĐ & Pru'
},{
	valueEmail:'4',nameEmail: 'Từ chối nhận email'
}]
agreeSmsTypes=[{
	valueSms:'1',nameSms: 'Thông tin HĐ'
},{
	valueSms:'3',nameSms: 'Thông tin HĐ & Pru'
},{
	valueSms:'4',nameSms: 'Từ chối nhận SMS'
}]
checkboxModel = {
	       value : true
	     };
